import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import DataWrapper from '../../../principal/containers/DataWrapper';
import AgendamentoDashboardStore from "../stores/AgendamentoDashboardStore";
import Footer from "../../../comum/components/Footer";
import FooterOptions from "../../../comum/components/FooterOptions"
import IconButton from "../../../comum/components/IconButton"
import FiltrosAgendamentoDashboard from "../componentes/FiltrosAgendamentoDashboard"
import { Container, Label } from "reactstrap";
import FooterContent from '../../../comum/components/FooterContent';
import { TabelaAgendamentoDashboardGeral } from '../componentes/TabelaAgendamentoDashboardGeral';
import { ListaGeral, ListaMember, ListaInfo, ListaNoShow } from '../componentes/TabelaDashboardGeral';
import LoadingImage from "../../../comum/components/LoadingImage";
import ModalForm from "../../../comum/components/ModalForm";
import { Redirect } from "react-router-dom";

import lscache from 'lscache';

@inject("store")
@DataWrapper
@observer

export class AgendamentoDashboard extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new AgendamentoDashboardStore(this.loginStore);
        this.state = {
            redirecionar: false
        }
        this.tipoAgendaSelecionado = null;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Informações Gate");
        this.appStore.showTopbar(true);
        this.appStore.showVoltarTopBar(false);

        this.controller.carregarTiposFainas();
        this.controller.carregarTiposAgendamentos();
    }

    modalAlerta() {
        return this.controller.modalAlerta && Date.now() < new Date('2020-05-02') &&
            <ModalForm className="tamanho-modal-acomproc"
                esconderSalvar={true}
                onClickCancelar={() => this.controller.modalAlerta = false}
                labelCancelar="FECHAR"
            >
                <p className="text-desistencia">
                    <h1 className="text-center"><strong>COMUNICADO</strong></h1>
                    Prezado Cliente,<br /><br />
                    Em virtude do Feriado do Dia do Trabalhador, no dia 01/05, o Terminal terá horários reduzidos, conforme abaixo.<br />
                    <br />
                    <strong>Recebimento de Container</strong><br />
                            Cheios: 00hs – 6hs<br />
                            Vazios: 00hs – 6hs<br />
                    <strong>Retirada de Container</strong><br />
                            Cheios: Sem expediente<br />
                            Vazios: 00hs – 6hs<br />
                    <strong>Armazéns</strong><br />
                            Sem Operação<br />
                    <br />
                    Caso exista necessidade de entrega, gentileza encaminhar sua solicitação para análise de viabilidade aos nossos canais de atendimento:<br />
                    <br />
                    <strong>Atendimento ao Cliente:</strong><br /> 53 3234.3030 - atendimento.tcrg@wilsonsons.com.br<br />
                    <strong>Import Desk:</strong><br /> 53 3234.3134 - importdesk.tcrg@wilsonsons.com.br<br />
                    <strong>Reefer Intelligence:</strong><br /> 53 3234.3144 - reeferintelligence.tcrg@wilsonsons.com.br<br />
                    <strong>Atendimento Armador:</strong><br /> 53 3234.3145 - atendimentoarmador.tcrg@wilsonsons.com.br<br /><br />
                    Cordialmente,<br />
                    TECON Rio Grande S/A
                </p>
            </ModalForm>
    };

    modalAviso() {
        if (this.controller.mostrarModalOpcoes) {
            return <ModalForm labelCancelar="VOLTAR"
                esconderSalvar={true}
                onClickCancelar={() => this.controller.setModalOpcoes(false)}
                opcoesHabilitadas={true}
            >
                <h2 className="mb-2">Selecione o Tipo de Agendamento desejado:</h2>
                {
                    this.controller.opcaoFainaSelecionada === 1 ?
                        <div className="justify-content-end">
                            <Label className="btn-primary" to="#" onClick={() => this.selecionaOpcao(1)}>ENTRADA DE CONTAINER CHEIO</Label><br />
                            <Label className="btn-primary" to="#" onClick={() => this.selecionaOpcao(2)}>ENTRADA DE CONTAINER VAZIO</Label><br />
                        </div>
                        :
                        <div className="justify-content-end">
                            <Label className="btn-primary" to="#" onClick={() => this.selecionaOpcao(122)}>RETIRADA DE CONTAINER DTA</Label><br />
                            <Label className="btn-primary" to="#" onClick={() => this.selecionaOpcao(9)}>RETIRADA DE CONTAINER DTC</Label><br />
                            <Label className="btn-primary" to="#" onClick={() => this.selecionaOpcao(123)}>RETIRADA DE CONTAINER CRP</Label><br />
                        </div>
                }
            </ModalForm>
        }
    }

    selecionaOpcao = async (tipoSelecionado) => {
        this.tipoAgendaSelecionado = tipoSelecionado;
        await this.controller.preparaLinkTipoAgendamento(tipoSelecionado);
        await this.setState({ redirecionar: true });
        this.controller.setModalOpcoes(false);
    }

    render() {
        if (this.state.redirecionar) {
            return <Redirect to={this.controller.opcoesTiposAgendamento} />
        }
        return (
            <div>
                <div className="form-wrapper">
                    <Container fluid>
                        {this.modalAviso()}
                        {this.modalAlerta()}
                        <FiltrosAgendamentoDashboard controller={this.controller} voltarParam={this.voltarParam} />
                        {this.controller.loading ?
                            <LoadingImage />
                            :
                            this.controller.atualizadoGeral ?
                                <ListaGeral controller={this.controller}
                                    lista={this.controller.listaDashboardGeral}
                                    tipoFaina={this.controller.tipoFainaTitulo}
                                    tipoFainaId={this.controller.dashboardFiltroTipoAgendamento}
                                    getTipoAgendaIdFromFainaId={this.controller.getTipoAgendaIdFromFainaId}
                                    tipoAgendamento={this.controller.tiposAgenda}
                                    dataConsulta={this.controller.dashboardFiltroData}
                                    horaLimite={this.controller.horaLimite}
                                    setModalOpcoes={this.controller.setModalOpcoes}
                                    setHoraDashboard={this.controller.setHoraDashboard}
                                    listaHorasCapacidade={this.controller.listaHorasCapacidade}
                                    opcoesModal={[1, 46].includes(this.controller.opcaoFainaSelecionada)}
                                    dataConsultaTitulo={this.controller.dataConsultaTitulo}
                                />
                                : <div />
                        }
                        {this.controller.loading ?
                            <LoadingImage />
                            :
                            this.controller.atualizadoGeral ?
                                <ListaMember controller={this.controller}
                                    lista={this.controller.listaDashboardMember}
                                    tipoFaina={"MEUS AGENDAMENTOS"}
                                    tipoFainaId={this.controller.dashboardFiltroTipoAgendamento}
                                    tipoAgendamento={this.controller.tiposAgenda}
                                    dataConsulta={this.controller.dashboardFiltroData}
                                />
                                : <div />
                        }
                        {this.controller.loading ?
                            <LoadingImage />
                            :
                            this.controller.atualizadoGeral ?
                                <ListaNoShow controller={this.controller}
                                    lista={this.controller.listaDashboardNoShow}
                                    tipoFaina={"AGENDAMENTOS VENCIDOS"}
                                    tipoFainaId={this.controller.dashboardFiltroTipoAgendamento}
                                    tipoAgendamento={this.controller.tiposAgenda}
                                    dataConsulta={this.controller.dashboardFiltroData}
                                />
                                : <div />
                        }
                        {this.controller.loading ?
                            <LoadingImage />
                            :
                            !process.env.rig && this.controller.atualizadoGeral ?
                                <ListaInfo controller={this.controller}
                                    lista={this.controller.listaDashboardInfo}
                                    tipoFaina={"OUTRAS INFORMAÇÕES"}
                                    tipoFainaId={this.controller.dashboardFiltroTipoAgendamento}
                                    tipoAgendamento={this.controller.tiposAgenda}
                                    dataConsulta={this.controller.dashboardFiltroData}
                                />
                                : <div />
                        }
                        {/* <TabelaAgendamentoDashboardGeral  controller={this.controller}/>  */}
                    </Container>
                </div>
                <Footer>
                    <FooterContent>
                        {this.controller.total !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.total}</b> {this.controller.total === 1 ? 'registro' : 'registros'} -
                                <a onClick={() => this.controller.carregarLista()}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                    </FooterContent>

                </Footer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/dashboard/tela/AgendamentoDashboard.js